'use strict';

require('./bootstrap');
require('./directives/SelectableReorderableDropdown');